import { IconButton } from "@mui/material";

import FormatISODateTime from "../../../../global/FormatISODateTime";
import PermissionWrapper from "../../../../global/PermissionWrapper";
import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { useNotePermissions } from "../../hooks/useNotePermissions";

export default function CustomAccordionActions({
  data,
  handleEdit,
  handleOnClickPin,
  notePermissionsHook = useNotePermissions,
}) {
  const { canEditCaseNotes } = notePermissionsHook(data);
  const { id: noteId, pinned: isPinned } = data;
  const updatedAt = data?.updatedAt || null;
  const iconSize = 24;

  const pinButtonStyles = {
    height: `${iconSize + 6}px`,
    width: `${iconSize + 6}px`,
    borderRadius: "4px",
    padding: "6px",
    backgroundColor: isPinned ? HNSColors.success[400] : HNSColors.neutrals[900],
    "&:hover": {
      backgroundColor: isPinned ? HNSColors.success[400] : HNSColors.success[700],
    },
  };

  const pinIconColor = isPinned ? HNSColors.neutrals[900] : HNSColors.success[400];

  return (
    <>
      {updatedAt && (
        <div className="flex items-center justify-end">
          <span className="text-[10px]" style={{ color: HNSColors.neutrals[400] }}>
            Last Updated: {FormatISODateTime(updatedAt, "", " - ")}
          </span>
        </div>
      )}
      <div className="flex flex-row items-center justify-end gap-2">
        <PermissionWrapper permission={canEditCaseNotes}>
          <IconButton onClick={() => handleEdit(data)} title="Edit Note">
            <Svg
              name={SvgEnum.HisEdit3}
              color={HNSColors.primary[500]}
              sx={{ height: iconSize, width: iconSize }}
            />
          </IconButton>
        </PermissionWrapper>

        <IconButton
          title={isPinned ? "Unpin Note" : "Pin Note"}
          onClick={() => handleOnClickPin(noteId, !isPinned)}
          sx={pinButtonStyles}
        >
          <Svg
            name={SvgEnum.HisPin}
            color={pinIconColor}
            sx={{ height: iconSize, width: iconSize }}
          />
        </IconButton>
      </div>
    </>
  );
}
